export default __webpack_public_path__ + "static/media/bbot-logo-circle.3abd61ab.svg";